// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zQfcO","favorite":"Card_favorite__xIvHZ","imageBox":"Card_imageBox__8x5Pa","cardBottom":"Card_cardBottom__z-5Fg","plusButton":"Card_plusButton__cOzZj"};